import {
    IPrivateInetTradeReport,
    IPrivateGeniumInetTradeReport,
    IPrivateTrade,
    OrderStatus,
    PrivateOrderTickData,
    PrivateTradeReportTickData,
    PrivateTradeTickData,
    TradeReportStatus,
    TRADE_REPORT_STATUS_MAP,
    ORDER_STATUS_MAP,
    PrivateDataError,
} from '../../types/api/PrivateTypes';
import { BySymbolByTradingDay, changeBySymbolByTradingDayState, PrivateDataRequested } from '../../types/api/Types';
import {
    REQUEST_PRIVATE_ORDERS_AND_TRADES_SUCCESS,
    REQUEST_PRIVATE_ORDERS_AND_TRADES_WAITING,
    PrivateActions,
    REQUEST_PRIVATE_ORDERS_AND_TRADES_FAILURE
} from '../../types/redux/PrivateTypes';
export interface IPrivateState {
    privateOrderAndTradeDoubleMap: BySymbolByTradingDay<
        PrivateDataRequested<{
            privateOrders: PrivateOrderTickData[],
            privateTrades: PrivateTradeTickData[],
            privateInetTradeReports: PrivateTradeReportTickData[],
            privateGeniumInetTradeReports: PrivateTradeReportTickData[]
        }>
    >
}

const initialState: IPrivateState = {
    privateOrderAndTradeDoubleMap: {},
}

export default function(state: IPrivateState = initialState, action: PrivateActions): IPrivateState {
    switch(action.type) {
        // REQUEST PRIVATE ORDERS
        case REQUEST_PRIVATE_ORDERS_AND_TRADES_WAITING: {
            const { symbol, tradingDay } = action.payload;
            const newPrivateOrderAndTradeDoubleMap = changeBySymbolByTradingDayState(state.privateOrderAndTradeDoubleMap, symbol, tradingDay, 'waiting');
            const newState: IPrivateState = {
                ...state,
                privateOrderAndTradeDoubleMap: newPrivateOrderAndTradeDoubleMap
            };
            return newState;
        }
        case REQUEST_PRIVATE_ORDERS_AND_TRADES_SUCCESS: {
            const { symbol, tradingDay, orders, trades, inetTradeReports, geniumInetTradeReports } = action.payload;
            // Change to 
            const statusesThatRequireExecIdFilter = ['replaced', 'new']
            const privateOrderTickdata: PrivateOrderTickData[] = orders.filter(order => (
                !statusesThatRequireExecIdFilter.includes(order.status)
                || (
                    statusesThatRequireExecIdFilter.includes(order.status)
                    // && order.exec_id.slice(0,2) === '0-'
                )
            )).map(order => ({
                ...order,
                timestamp: order.last_updated || '',
                update_code: ORDER_STATUS_MAP[order.status] as OrderStatus,
                tickdata_type: 'PrivateOrder'
            }));
            const { privateTradeTickData, privateInetTradeReportsTickData, privateGeniumTradeReportsTickData } = privateTradesToTickData(trades, inetTradeReports, geniumInetTradeReports);
            const newPrivateData = {
                privateOrders: privateOrderTickdata,
                privateTrades: privateTradeTickData,
                privateInetTradeReports: privateInetTradeReportsTickData,
                privateGeniumInetTradeReports: privateGeniumTradeReportsTickData
            };
            const newPrivateOrderAndTradeDoubleMap = changeBySymbolByTradingDayState(state.privateOrderAndTradeDoubleMap, symbol, tradingDay, newPrivateData);
            const newState: IPrivateState = {
                ...state,
                privateOrderAndTradeDoubleMap: newPrivateOrderAndTradeDoubleMap
            };
            return newState;
        }
        case REQUEST_PRIVATE_ORDERS_AND_TRADES_FAILURE: {
            const { symbol, tradingDay, error } = action.payload;
            const exampleError: PrivateDataError = {
                error: error
            };
            const newPrivateOrderAndTradeDoubleMap = changeBySymbolByTradingDayState(state.privateOrderAndTradeDoubleMap, symbol, tradingDay, exampleError);
            const newState: IPrivateState = {
                ...state,
                privateOrderAndTradeDoubleMap: newPrivateOrderAndTradeDoubleMap
            };
            return newState;
        }
        default: {
            return state;
        }
    }
}

// HELPER FUNCTIONS.
export const privateTradesToTickData = (
    trades: IPrivateTrade[],
    inetTradeReports: IPrivateInetTradeReport[],
    geniumInetTradeReports: IPrivateGeniumInetTradeReport[]
) => {
    const privateTradeTickData: PrivateTradeTickData[] = trades.map(trade => ({
        ...trade,
        tickdata_type: 'PrivateTrade',
        update_code: 'Execution'
    }));
    const privateInetTradeReportsTickData: PrivateTradeReportTickData[] = inetTradeReports.map(inetTR => ({
        ...inetTR,
        timestamp: inetTR.last_updated ?? inetTR.timestamp ,
        status: TRADE_REPORT_STATUS_MAP[inetTR.status] ?? inetTR.status,
        tickdata_type: 'PrivateTradeReport',
        update_code: (TRADE_REPORT_STATUS_MAP[inetTR.status] || inetTR.status) as TradeReportStatus
    }));
    const privateGeniumTradeReportsTickData: PrivateTradeReportTickData[] = geniumInetTradeReports.map(geniumTR => ({
        ...geniumTR,
        timestamp: geniumTR.last_updated ?? geniumTR.timestamp,
        status: TRADE_REPORT_STATUS_MAP[geniumTR.status] ?? geniumTR.status,
        update_code: (TRADE_REPORT_STATUS_MAP[geniumTR.status] ?? geniumTR.status) as TradeReportStatus,
        tickdata_type: 'PrivateTradeReport'
    }));
    return {
        privateTradeTickData,
        privateInetTradeReportsTickData,
        privateGeniumTradeReportsTickData
    }
}